import React from 'react';

const BrandDivider = ({ className = '' }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden="true">
    <span className="h-px w-12 sm:w-20 bg-atithi-saffron" />
    <svg
      viewBox="0 0 120 24"
      className="h-5 w-24 text-atithi-saffron"
      fill="currentColor"
    >
      <path d="M60 2c-8 0-14 4-18 10 4-6 10-10 18-10s14 4 18 10c-4-6-10-10-18-10zm-28 12c4 4 10 6 16 6h24c6 0 12-2 16-6-4 4-10 6-16 6H48c-6 0-12-2-16-6z" />
    </svg>
    <span className="h-px w-12 sm:w-20 bg-atithi-saffron" />
  </div>
);

export default BrandDivider;
